import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Pagination from 'antd/lib/pagination';

import TableLoading from '../TableLoading';
import { request, itemRender, formatDate } from '../../services/utilities';
import { notifyError } from '../../services/notify';
import { startBlock, stopBlock } from '../../actions/redux-block';
import CreateNote from '../Modals/CreateNote';
import { staffname } from '../../services/utilities';

const StimulationChartTable = ({ mydata }) => {
	const [loading, setLoading] = useState(true);
	const [notes, setNotes] = useState([]);
	const [meta, setMeta] = useState({
		currentPage: 1,
		itemsPerPage: 10,
		totalPages: 0,
	});
	const [showModal, setShowModal] = useState(false);

	const dispatch = useDispatch();

	const ivf = useSelector(state => state.sidepanel.item);

	const fetchNotes = useCallback(
		async page => {
			try {
				dispatch(startBlock());
				const p = page || 1;
				const url = `patient-notes?page=${p}&limit=10&ivf_id=${ivf.id}`;
				const rs = await request(url, 'GET', true);
				const { result, ...meta } = rs;
				setNotes(result);
				setMeta(meta);
				dispatch(stopBlock());
			} catch (error) {
				console.log(error);
				dispatch(stopBlock());
				notifyError('error fetching notes');
			}
		},
		[dispatch, ivf]
	);

	useEffect(() => {
		if (loading) {
			fetchNotes();
			setLoading(false);
		}
	}, [fetchNotes, loading]);

	const onNavigatePage = nextPage => {
		fetchNotes(nextPage);
	};

	const newEntry = () => {
		document.body.classList.add('modal-open');
		setShowModal(true);
	};

	const closeModal = () => {
		setShowModal(false);
		document.body.classList.remove('modal-open');
	};

	const updateNote = item => {
		setNotes([item, ...notes]);
		setMeta({
			currentPage: 1,
			itemsPerPage: 10,
			totalPages: notes.length + 1,
		});
	};

	return (
		<div className="col-sm-12">
			<div className="element-wrapper">
				{/* <div className="element-actions flex-action">
					<a
						className="btn btn-sm btn-secondary text-white ml-3"
						onClick={() => newEntry()}
					>
						New Note
					</a>
				</div> */}
				{/* <h6 className="element-header">IVF Notes</h6> */}
				<div className="element-box p-3 m-0">
					{loading ? (
						<TableLoading />
					) : (
						<div className="table-responsive">
							<table className="table table-striped">
								<thead>
									<tr>
										<th>Date</th>
										<th>Created By</th>
										<th>Type</th>
										<th>Antagonist</th>
										<th>PIII</th>
										<th>LMP</th>
										<th>Hmg</th>
										<th>Fsh</th>
										<th>Dose</th>
										<th>Suprecur</th>
									</tr>
								</thead>
								<tbody>
									{mydata.map((item, i) => {
										return (
											<tr key={i}>
												<td nowrap="nowrap">{formatDate(item.createdAt, 'D-MMM-YYYY h:mm A')}</td>
												<td>{item?.created_by || item?.createdBy || item?.staff?.username || '--'}</td>
												<td>{item.type}</td>
												<td>{item.antagonist || '--'}</td>
												<td>{item.piii || '--'}</td>
												<td>{item.lmp || '--'}</td>
												<td>{item.hmg || '--'}</td>
												<td>{item.fsh || '--'}</td>
												<td>{item.dose || '--'}</td>
												<td>{item.suprecur || '--'}</td>
											</tr>
										);
									})}
								</tbody>
							</table>
							{meta && (
								<div className="pagination pagination-center mt-4">
									<Pagination
										current={parseInt(meta.currentPage, 10)}
										pageSize={parseInt(meta.itemsPerPage, 10)}
										total={parseInt(meta.totalPages, 10)}
										showTotal={total => `Total ${total} notes`}
										itemRender={itemRender}
										onChange={current => onNavigatePage(current)}
										showSizeChanger={false}
									/>
								</div>
							)}
						</div>
					)}
				</div>
			</div>
			{/* {showModal && (
				<CreateNote
					closeModal={closeModal}
					updateNote={updateNote}
					ivf_id={ivf.id}
					patient={patient}
					type="ivf"
				/>
			)} */}
		</div>
	);
};

export default StimulationChartTable;
